// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-518a7f3e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Share/UpdateShareAdvocateModal.vue
// module id = 1008
// module chunks = 1